export const version = "5.18.0";
export const major = Number("5");
export const minor = Number("18");
export const patch = Number("0");
export const preReleaseLabel = undefined || null;
export const preReleaseNumber = Number(undefined) || null;
export default version;